var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaDerecha22X22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9631 11.2685C13.0955 11.114 13.0955 10.886 12.9631 10.7316L8.07666 5.03076C7.82955 4.74247 7.86294 4.30846 8.15123 4.06135C8.43951 3.81425 8.87353 3.84764 9.12063 4.13592L14.007 9.83672C14.5808 10.5061 14.5808 11.4939 14.007 12.1633L9.12063 17.8641C8.87353 18.1524 8.43951 18.1858 8.15123 17.9387C7.86294 17.6916 7.82955 17.2575 8.07666 16.9693L12.9631 11.2685Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaDerecha22X22);
export default __webpack_public_path__ + "static/media/FLECHA_DERECHA_22X22.930ab179aaf9995d7b88907acc785f99.svg";
export { ForwardRef as ReactComponent };